import Vue from 'vue'
import App from './App.vue'
import router from './router'
import {store} from './_store'
import { i18n } from '@/plugins/i18n'
import { Trans } from './plugins/Translation'
import Meta from 'vue-meta'
import MomentPlugin from './plugins/MomentPlugin.vue'
// import './registerServiceWorker'
import Login from './components/Login'

import AxiosPlugin from "@/plugins/AxiosPlugin"
import VueCookies from 'vue-cookies'
import VueScrollTo from 'vue-scrollto'
import Notifications from 'vue-notification'
import BootstrapVue from 'bootstrap-vue'
import Util from "@/plugins/Util";

import './assets/styles/main.scss'
import './assets/intro/intro'

Vue.prototype.$i18nRoute = Trans.i18nRoute.bind(Trans)

Vue.use(VueCookies)
Vue.use(VueScrollTo, {
    y: true,
    offset: 0,
    container: "body"
})
Vue.use(AxiosPlugin)
Vue.use(Notifications)
Vue.use(BootstrapVue)
Vue.use(Util)
Vue.use(Meta)
Vue.use(MomentPlugin)


Vue.component('Login', Login)

// Vee-Validate
import VeeValidate, {Validator} from 'vee-validate'
import it from 'vee-validate/dist/locale/it'

Vue.use(VeeValidate);
Validator.localize('it', it);

import UniqueId from 'vue-unique-id';
Vue.use(UniqueId);

// Analytics
// import VueAnalytics from 'vue-analytics'
//
// Vue.use(VueAnalytics, {
//     id: 'G-0XG38DYP2F',
//     router,
//     debug: {
//         enabled: true, // default value
//         trace: true, // default value
//         sendHitTask: true // default value
//     }
// })
//
//

import moment from "moment"
import round from 'vue-round-filter';

import vueSmoothScroll from 'vue2-smooth-scroll'
Vue.use(vueSmoothScroll)

Vue.filter('formatDate', function(value) {
    if (value) {
        return moment.unix(value).format('DD/MM hh:mm')
    }
})

Vue.filter('dateWithTime', function(value) {
    if (value) {
        return moment(value.toString(),'YYYY-MM-DDThh:mm:ss').format('DD/MM hh:mm')
    }
})

Vue.filter('date', function(value) {
    if (!value) return ''
    return moment(value.toString(),'YYYYMMDD').format('DD MMMM YYYY');
})

Vue.filter('year', function(value) {
    if (!value) return ''
    return moment(value.toString(),'YYYYMMDD').format('YYYY');
})

Vue.filter('days', function(value) {
    if (!value) return ''
    return moment(value.toString(),'YYYYMMDD').format('DD MMMM');
})

Vue.filter('fromNow', function(value) {
    if (!value) return ''
    // Se sono passati più di 7 giorni non ha senso, quindi in quel caso diamo un formato DD MMMM YYYY
    let data = moment(value.toString())
    if (moment().subtract(7,'days') > data)
        return data.format('DD MMMM YYYY');
    return data.fromNow();
})

Vue.filter('abs', function(value) {
    return Math.abs(value)
})

import VueIntro from 'vue-introjs';
Vue.use(VueIntro);

router.afterEach(() => {
    store.commit('loading',false)
    store.commit('menu_open',false)
})

Vue.config.productionTip = false
new Vue({
    router,
    i18n,
    store,
    filters: {
        round,
    },
    render: h => h(App),
    mounted() {
        this.$store.commit('vue', {
            '$http': this.$http,
            '$notify': this.$notify,
            '$cookies': this.$cookies,
            '$modal': this.$modal
        })
    }
}).$mount('body')

